module.exports = __webpack_public_path__ + "static/media/grafana_icon.03aa4447.svg";